import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

export const useStyles = makeStyles(theme => ({
  heading: {
    margin: '12px 20px',
    color: theme.palette.primary.main,
    fontWeight: 500,
    lineHeight: 'normal',
  },
}))

export const Root = styled.div`
  display: grid;
  gap: 30px 40px;
  grid-template-columns: repeat(auto-fill,300px);
  width: 100%;
  padding: 15px 0px 33px 50px;
`

export const HeadingContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
`
